import { css, cx } from "@emotion/css";
import type { ReactNode } from "react";
import { use100vh } from "react-div-100vh";

interface FullHeightContainerProps {
	className?: string;
	children: ReactNode;
}

export const FullHeightContainer = ({
	className,
	children,
}: FullHeightContainerProps) => {
	const height = use100vh();

	return (
		<div
			className={cx(
				className,
				css`
          overflow-y: scroll;
          height: calc(
            ${height}px - env(safe-area-inset-top, 0px) - env(
                safe-area-inset-bottom,
                0px
              )
          );
        `,
			)}
		>
			{children}
		</div>
	);
};
